
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/not-available",
      function () {
        return require("private-next-pages/not-available/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/not-available"])
      });
    }
  